import React, { useState,useEffect } from 'react';

import '../Assets/css/custom.css';
import '../Assets/css/w3-css.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import moment from 'moment';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import "react-datepicker/dist/react-datepicker.css";  
import CommonAPI from '../Common/CommonAPI';
import CommonAPI2 from '../Common/FD_BILL_APIs';
import FadeLoader from "react-spinners/HashLoader"; 


function FDWithdrawnDeposit  (props)  {   

    const [SuccessLoading,setSuccessLoading] =useState(true);
    const [FDList,setFDList]  =useState([]);

    const ResponseLoadingModal = () => {
        return(
            <Modal
            size="lg"
            centered 
            className="loading1" show={SuccessLoading}>          
                  <FadeLoader
                  height={25}
                  width={5}
                  radius={2}
                  margin={2}
                  color={"#197b55"}
                  size={"80px"} this also works
                  loading={SuccessLoading}
                />       
           </Modal>
         )
      }

    const GetFDAPI  = () =>{
        CommonAPI2.FixedDeposits((results) =>{   
            if(results){                    
                setFDList(results.fdList.filter(e=>e.status ==="WDR")); 
                setSuccessLoading(false)
            }            
        });
      } 

    useEffect( () => {
        GetFDAPI();  
      },[])  ;

    
     if(SuccessLoading){
        return ( <div>{ResponseLoadingModal()}</div> );
    }else{

        return (
            <div>
                <Row className='block'>
                    <p className='p-line2'>WITHDRAWN FIXED DEPOSIT INQUIRY </p>
                </Row>
                <div>
                <Row lg={12}>
                    <Col lg={12} className='rmv-pad3 block text-color'>   
                        <div class="tableFixHead">                           
                            <Table    hover responsive>
                            <thead >
                                <tr>
                                <th className='td-width5 t-left'>No:<p></p></th>
                                <th className='td-width1 t-left'>Fixed Deposit<br/> Number</th>
                                <th className='td-width1 t-left'>Interest Required <br/>Method</th>                           
                                <th className='td-width7 '>Capital<br/> LKR</th>                           
                                <th className='td-width3 '>Interest <br/>Amount LKR</th>                           
                                <th className='td-width3 t-right'>Total LKR<p></p></th>                           
                                <th className='td-width11 t-right'>Interest <br/>Paid LKR</th>                           
                                <th className='td-width3 t-right'>Maturity <br/>Date</th>                           
                                </tr>
                            </thead>
                            <tbody className='scroll2'>
                            {FDList.length>0?FDList.map(( listValue, index ) => {
                            return( 
                                <tr>
                                    <td className='td-width5'>
                                        <p className='tb-text m-top t-left'>{index + 1} </p>
                                    </td>
                                    <td className='td-width3'>
                                        <p className='tb-text m-top t-left'>{listValue.fdNumber}</p>
                                    </td>
                                    <td className='td-width t-right '>
                                        <p className='tb-text  m-top t-left'>{listValue.interestPaymentMode === "A" ? "At Maturity" : listValue.interestPaymentMode === "M" ? "Monthly" : listValue.interestPaymentMode === "Q" ? "Quarterly" : null}</p>
                                    </td>
                                    <td className='td-width3'>
                                        <p className='tb-text  m-top '>{listValue.depositAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    </td>
                                    <td className='td-width3'>
                                        <p className='tb-text m-top '>{listValue.totalInterestAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    </td>
                                    <td className='td-width3 '>
                                        <p className='tb-text m-top t-right'>{(listValue.depositAmount + listValue.totalInterestAmount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    </td>
                                    <td className='td-width3'>
                                        <p className='tb-text m-top t-right'> {listValue.paidAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    </td>
                                    <td className='td-width3 t-right'>
                                        <p className='tb-text m-top t-right'> {moment(listValue.matirutyDate).format('DD/MM/YYYY')}</p>
                                    </td>
                                </tr>
                            )
                                }):
                                <Row className='tablebody'>
                                    <p className='h-text block-top'>No Records</p>
                                </Row>
                                }  
                            </tbody>
                            </Table>
                        </div>                      
                    </Col>                            
                </Row>
                </div>
            </div>
          );
        }
    }

export default FDWithdrawnDeposit;